import { render, staticRenderFns } from "./AcaoObjetoTestPanel.vue?vue&type=template&id=642295a6&scoped=true"
import script from "./AcaoObjetoTestPanel.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoTestPanel.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoTestPanel.vue?vue&type=style&index=0&id=642295a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642295a6",
  null
  
)

export default component.exports